'use strict';

var adapters = require('@leancloud/platform-adapters-node');

module.exports = function (AV) {
  AV.setAdapters(adapters);
  return AV;
};


//////////////////
// WEBPACK FOOTER
// ./~/leancloud-storage/dist/node/entry/use-adapters.js
// module id = 679
// module chunks = 0